import React from "react";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import { useUserDataContext } from "@/store/UserProvider";
import Typography from "@/ui/Typography/Typography";
import { ArrowIcon } from "@/assets/icons";
import { useTranslation } from "react-i18next";
import {
  getCardLastNumbers,
  HIDDEN_CARD_MASK,
} from "./paymentOptionHelpers";
import cls from "./styles.module.scss";

interface ChangePaymentOptionProps {
  onChange: () => void;
}

export const ChangePaymentOption = ({ onChange }: ChangePaymentOptionProps) => {
  const { t } = useTranslation();
  const { user, paymentOption } = useUserDataContext();

  const currentCard = user?.saved_payment_methods?.find(
    (elem) => elem.payment_method_id === paymentOption
  )?.card_metadata?.last4;

  return (
    <FlexColumn gap={2} className={cls.wrapper} onClick={onChange}>
      <Typography className={cls.title}>
        {t("paymentOptions.paymentOption")}
      </Typography>
      <FlexRow justifyContent="space-between" alignItems="center">
        <Typography className={cls.text}>
          {`${t("paymentOptions.card")} ${HIDDEN_CARD_MASK}${getCardLastNumbers(
            currentCard
          )}`}
        </Typography>
        <FlexRow gap={4} alignItems="center" className={cls.changeBtn}>
          {t("paymentOptions.change")}
          <div className={cls.changeBtnIcon}>
            <ArrowIcon />
          </div>
        </FlexRow>
      </FlexRow>
    </FlexColumn>
  );
};
